"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewDetails", {
    enumerable: true,
    get: function() {
        return ReviewDetails;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewDetails = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    subject: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    subjectGroup: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId.nullable(),
        name: _zod.z.string().nullable()
    }),
    reviewDueDate: _utilsisomorphic.transformDate.nullable(),
    authorTurnStats: _zod.z.object({
        total: _zod.z.number(),
        completed: _zod.z.number()
    }),
    signerTurnStats: _zod.z.object({
        total: _zod.z.number(),
        completed: _zod.z.number()
    }),
    authorProgressPercent: _zod.z.number(),
    signerProgressPercent: _zod.z.number(),
    totalProgressPercent: _zod.z.number(),
    totalFormsCount: _zod.z.number(),
    completedFormsCount: _zod.z.number(),
    unassignedFormsCount: _zod.z.number(),
    externalFormsCount: _zod.z.number(),
    threeSixtyFormsCount: _zod.z.number(),
    pendingThreeSixtyFormsCount: _zod.z.number(),
    completeDate: _utilsisomorphic.transformDate.nullable(),
    completed: _models.ReviewModel.shape.completed,
    closed: _models.ReviewModel.shape.closed,
    adminsOnly: _zod.z.boolean().optional()
});
